// extracted by mini-css-extract-plugin
export default {"head":"iLYrIBfDaMgzfKRY7olP","headBody":"foJekZB_MLQ_HfGTDD0v","required":"KB7Mmhd0nYnGj5KQuiOz","any":"cBRnFXcSxgYnUaKQ2Cfx","detail":"W3z277HG8eHjfQHcpJOR"};